import { useEffect } from 'react';
import { RegistrationContainer } from '@bumble/app/components/RegistrationContainer';
import { useAccount } from '@bumble/app/hooks/use-account';
import { Box, Button, Divider, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export const Logout = () => {
  const { logout } = useAccount();

  useEffect(() => {
    logout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RegistrationContainer>
      <Typography variant="h3" component="h1" mb={2}>
        Logout successful!
      </Typography>
      <Typography variant="body1" component="p" py={2} mb={2}>
        Please close the session window.
      </Typography>
      <Box py={6}>
        <Divider />
      </Box>
      <Button size="small" variant="text" component={Link} to="/login">
        Go back to login
      </Button>
    </RegistrationContainer>
  );
};
